<template> 
  <v-container class="app-page-container">
        <v-card class="shadow-none app-page-card" v-if="user">

                    <v-card-title >
                      <v-flex xs6>
                          Messages
                      </v-flex>
                    </v-card-title>

                    <v-card-text class = "leaderboard">
                        <v-layout row wrap class="leaderboard__head">
                          <v-flex xs2> </v-flex>
                          <v-flex xs1> 
                              id
                          </v-flex>
                          <v-flex xs1> 
                              type
                          </v-flex>
                          <v-flex xs5> 
                            title
                          </v-flex>
                          <v-flex xs2> 
                            last used
                          </v-flex>
                          <v-flex xs1> 
                            owner
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap v-for="(message, index) in messageList" :key="index" class="leaderboard__row"> 
                          <v-flex xs2> 
                              <v-icon @click="editMessage(message.id)">mdi-pencil</v-icon>
                              <v-icon @click="deleteMessage(message.id)">mdi-delete</v-icon>
                              <v-icon @click="showGroups = index; feedback = null">mdi-chat</v-icon>
                          </v-flex>
                          <v-flex xs1> 
                            {{message.id}}
                          </v-flex>      
                          <v-flex xs1> 
                            {{message.message_type_id}}
                          </v-flex>
                          <v-flex xs5 @click="editMessage(message.id)"> 
                            {{message.title}}
                          </v-flex>
                          <v-flex xs2> 
                            {{message.last_used_at}}
                          </v-flex>
                          <v-flex xs1> 
                            {{message.owner_id}}
                          </v-flex>
                          <v-flex xs1> </v-flex>
                          <v-flex xs10>
                            <v-card v-if="showGroups == index && groupList">
                              <v-icon class="btn-close" @click="showGroups = -1; feedback = null;">close</v-icon>  
                              <v-card-title>
                                Send to selected groups
                              </v-card-title>
                              <v-card-text>
                                <v-layout row wrap>
                                  <v-flex xs8>                          
                                    <v-autocomplete
                                          v-model="selected_groups"
                                          :items="groupList"
                                          item-text="name"
                                          item-value="id"
                                          label="Select groups"
                                          clearable
                                          multiple                        
                                          small-chips         
                                    ></v-autocomplete>
                                  </v-flex>
                                  <v-flex xs1></v-flex>
                                  <v-flex xs3>
                                    <v-date-picker v-model="finishDate"></v-date-picker>
                                  </v-flex>
                                  <v-flex xs12>
                                    <p v-if="feedback">{{feedback}}</p>
                                    <v-btn dense @click="sendMessage(message.id)">Send to users in selected groups</v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-text>
                      <v-layout justify-center>
                          <v-icon @click="editMessage(0)" size="medium">mdi-plus-circle-outline</v-icon> 
                      </v-layout>
                    </v-card-text>

      </v-card>
  </v-container>
</template>
<script>
import axios from '../../axios-auth'
import {mapGetters} from 'vuex'
 
export default {
    data() {
      return {
        messageList: null,
        groupList: null,
        selected_groups: [],
        showGroups: -1,
        feedback: null,
        finishDate: null
      }
    },
    mounted () {
      this.initData()
   },
   computed: 
      mapGetters([
                      'user'
                  ])
   ,
   methods: {
    initData() {
      this.$store.commit('setBreadCrumbs',[{text: 'Messages', href: '/message_admin_list'}])//#
      this.getMessages()
      this.finishDate = new Date().toISOString().slice(0, 10)
    },
    getMessages() {
      this.feedback = null
      axios.get('/get-admin-messages', this.$store.getters.getAxiosConfig)
        .then(res => {
            // set data to store
            this.messageList = res.data.list
            axios.get('/get-teaching-groups', this.$store.getters.getAxiosConfig)
              .then(res => {
                  // set data to store
                  this.groupList = res.data.teach_groups
              })
              .catch(error => {
                  this.$store.commit('setFeedback', error)          
              })
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
    editMessage(id) {
        this.$router.push({name:'edit_message', params: {id: id}})
    },
    sendMessage(id) {
      const data = {
        group_list: this.selected_groups.toString(),
        message_id: id,
        finish_date: this.finishDate
      }
      axios.post('/send-message', data, this.$store.getters.getAxiosConfig)
        .then((res) => {
            this.feedback = res.data.message
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    }
   }
  }
</script>

<style>

</style>